const API_URL = "https://api.travelpayouts.com/v1/flight_search";
const API_TOKEN = "a4d6f7a3469f89bec2b7264f9cd986cc"; //for travelpayouts
const API_ACCESS_TOKEN = "duffel_test_2Pc9oQR0lZs-IskErm63tVSdMIS1d_EpHLmfoTXIxBL" //new API
const API_MARKER = "357974";
export {API_URL, API_TOKEN, API_MARKER, API_ACCESS_TOKEN}
